import { ITimetableSchedule } from 'src/api/getTimetable';

const contentKey = (schedule: ITimetableSchedule): string =>
  `${schedule.day_of_week}|${schedule.start_time}|${schedule.end_time}|${schedule.menu_id ?? ''}|${schedule.menu_set_id ?? ''}|${schedule.price_scheme_id ?? ''}`;

// null colour_order is how a schedule row signals "this is the current default" - the same
// ground-truth signal resolveAffectedScheduleBlocks/resolveScheduleColours use.
const isDefault = (schedule: ITimetableSchedule): boolean => schedule.colour_order === null;

/**
 * Flags a schedule whose block content (day, time bounds and entity) hasn't changed, but whose
 * Default status has - e.g. picking an already-scheduled menu as the new default promotes its
 * existing block to Default without reassigning any entity, so getChangedScheduleIds' content
 * diff sees nothing different and won't flag it. A block whose content DID change is already
 * covered by that diff, so this only adds ids for the unchanged-content, flipped-default case.
 */
export const getDefaultStatusChangedScheduleIds = (
  originalSchedules: ITimetableSchedule[],
  previewSchedules: ITimetableSchedule[],
): Set<string> => {
  const wasDefaultByContent = new Map(originalSchedules.map((schedule) => [contentKey(schedule), isDefault(schedule)]));

  return new Set(
    previewSchedules
      .filter((schedule) => {
        const wasDefault = wasDefaultByContent.get(contentKey(schedule));
        return wasDefault !== undefined && wasDefault !== isDefault(schedule);
      })
      .map((schedule) => schedule.schedule_id),
  );
};
